<!--Header-->
<div class="TextCenter">
	<h4>Facility ScanStation Settings:</h4>
</div>

<!--Name-->
<div class="fd-Menu TopMargin">
	<label for="EnableMealAccounting" style="margin: 0">Enable Meal Accounting on ScanStations:</label>
	<input id="EnableMealAccounting" [(ngModel)]="EnableMealAccounting" class="form-control CheckBox" type="checkbox" />

	<label for="EnablePersonalItem" style="margin: 0">Enable Personal Item Collection:</label>
	<input id="EnablePersonalItem" [(ngModel)]="EnablePersonalItem" class="form-control CheckBox" type="checkbox" />

	<label for="AwayBarcode" style="margin: 0">Use Away School Students Barcode from Home School:</label>
	<input id="AwayBarcode" [(ngModel)]="AwayBarcode" class="form-control CheckBox" type="checkbox" />

	<label for="AwayPhoto" style="margin: 0">Use Away School Students Photo from Home School:</label>
	<input id="AwayPhoto" [(ngModel)]="AwayPhoto" class="form-control CheckBox" type="checkbox" />
</div>

<div *ngIf="EditMode == true" class="TextCenter TopMargin">
	<label class="WarnText">NOTE: you have to go to the last page to save your changes and update the facility</label>
</div>

<!--Next-->
<div class="TextCenter TopMargin">
	<button class="btn btn-primary" (click)="onNext()">Next</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
